import { useMemo } from 'react';
import FilterDropdown from 'components/elements/Dropdown/FilterDropdown';
import {
  useDashboardCompanyStakeholderTypes,
  useDashboardCompanyStakeholderTypesExclusions,
} from 'state/dashboard';
import { COMPANY_TYPES } from 'utils/constants/companyTypes';

const StakeholdersInvolved = () => {
  const [companyStakeholderTypes, setCompanyStakeholderTypes] =
    useDashboardCompanyStakeholderTypes();
  const [companyStakeholderTypesExclusions, setCompanyStakeholderTypesExclusions] =
    useDashboardCompanyStakeholderTypesExclusions();

  const handleClearAll = () => {
    setCompanyStakeholderTypes('');
    setCompanyStakeholderTypesExclusions('');
  };

  const handleClearAllExclusions = () => {
    setCompanyStakeholderTypesExclusions('');
  };

  const transformForChekboxes = (values: string) => {
    return values ? values.split(',') : [];
  };

  const trasformedForChekboxes = useMemo(() => {
    return transformForChekboxes(companyStakeholderTypes);
  }, [companyStakeholderTypes]);

  const transformedExclusionsForChekboxes = useMemo(() => {
    return transformForChekboxes(companyStakeholderTypesExclusions);
  }, [companyStakeholderTypesExclusions]);

  const transformForIngestion = (values: string[]) => {
    return values.length ? values.join(',') : '';
  };

  return (
    <FilterDropdown
      options={COMPANY_TYPES}
      onClearAll={handleClearAll}
      checkedValues={trasformedForChekboxes}
      setCheckedValues={(values) =>
        setCompanyStakeholderTypes(transformForIngestion(values))
      }
      description="Refine projects by contacts available"
      isExclusion
      setExclusionValues={(values) =>
        setCompanyStakeholderTypesExclusions(transformForIngestion(values))
      }
      exclusionValues={transformedExclusionsForChekboxes}
      onExclusionClearAll={handleClearAllExclusions}
    >
      Stakeholders Involved
    </FilterDropdown>
  );
};

export default StakeholdersInvolved;
